export const CAMPAIGN_SET = 'CreateEditCampaign/campaign-set';
export const CREATE_CAMPAIGN_FINISH = 'CreateEditCampaign/create-campaign-finish';
export const CREATE_CAMPAIGN_MODAL_OPEN = 'CreateEditCampaign/create-campaign-modal-open';
export const CURRENT_STEP_SET = 'CreateEditCampaign/current-step-set';
export const DETAILS_VALUE_CHANGE = 'CreateEditCampaign/details-value-change';
export const EDIT_CAMPAIGN_MODAL_OPEN = 'CreateEditCampaign/edit-campaign-modal-open';
export const PREVIOUS = 'CreateEditCampaign/previous';
export const SHOW_SET = 'CreateEditCampaign/show';
export const SAVING_ERROR_SET = 'CreateEditCampaign/saving-error-set';
export const RESET = 'CreateEditCampaign/reset';
